import { useMutation } from '@tanstack/react-query';
import { getSBOMTemplate } from 'src/services/productInventory';

export function useDownloadSBOM(account: string, configurationPID: string, productName: string) {
  const { mutateAsync, data, isLoading, isError, isSuccess, reset } = useMutation(['getSBOMTemplate'], () =>
    getSBOMTemplate(account, configurationPID, productName)
  );

  if (isSuccess) {
    window.open(data?.downloadURL, '_blank');
    reset();
  }

  const handleClick = async () => {
    await mutateAsync();
  };

  return { handleClick, isLoading, isError };
}
